import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { ListLeaderboardComponent } from './list-leaderboard/list-leaderboard.component';


const routes: Routes = [
  {
    path: '',
    component: ListLeaderboardComponent,
  },

  { path: '', pathMatch: 'full', redirectTo: 'catalog/leaderboard' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LeaderboardRoutingModule { }
